<!--分路段超速提醒-->
<template>
  <div>
    <div class="page_header">
      <span class="page_title">{{ $t("speedlimit.SubspeedWarn") }}</span>
    </div>
    <div class="page_container">
      <el-row :gutter="10" style="margin-right: 10px">
        <el-col :span="8" :offset="0">
          <div
            style="border: 1px solid #c5d0e2; border-radius: 4px; padding: 8px"
          >
            <div style="">
              <div style="display: flex; align-items: center">
                <span
                  style="
                    flex: 1;
                    font-size: 12px;
                    font-weight: bold;
                    color: #0f1a3a;
                  "
                  >{{ $t("speedlimit.routelist") }}</span
                >
                <div>
                  <kl-label
                    :title="$t('public.add')"
                    @click="onAddLineClick"
                    icon="icon-icon_operat_increa"
                    :iconSize="16"
                    :fontSize="12"
                    style="margin-right: 12px; cursor: pointer"
                  />
                  <kl-label
                    :title="$t('public.edit')"
                    @click="onEditClick"
                    icon="icon-icon_buslist_xxfb"
                    :iconSize="16"
                    :fontSize="12"
                    style="margin-right: 12px; cursor: pointer"
                  />

                  <kl-label
                    :title="$t('public.del')"
                    @click="onDelLineClick"
                    icon="icon-icon_operat_delete"
                    :iconSize="16"
                    :fontSize="12"
                    style="cursor: pointer"
                  />
                </div>
              </div>
              <div style="height: calc(100vh - 450px); overflow: auto">
                <el-table
                  v-loading="loading"
                  size="mini"
                  :data="lineList"
                  border
                  highlight-current-row
                  style="width: 100%"
                  @row-click="tableClickRow"
                >
                  <el-table-column type="index" align="center" width="45">
                  </el-table-column>
                  <el-table-column
                    prop="routeName"
                    align="center"
                    :label="$t('arealimitset.linename')"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div style="margin-top: 16px">
              <div style="display: flex; align-items: center">
                <span
                  style="
                    flex: 1;
                    font-size: 12px;
                    font-weight: bold;
                    color: #0f1a3a;
                  "
                  >{{ $t("speedlimit.vehicleset") }}</span
                >
                <div>
                  <kl-label
                    :title="$t('public.Set')"
                    icon="icon-icon_operat_increa"
                    :iconSize="16"
                    @click="setVehicleSpeedLimit"
                    :fontSize="12"
                    style="margin-right: 12px; cursor: pointer"
                  />
                  <kl-label
                    :title="$t('public.UnBind')"
                    icon="icon-icon_operat_delete"
                    :iconSize="16"
                    :fontSize="12"
                    @click="removeVehicleSpeedLimitSet"
                    style="margin-right: 12px; cursor: pointer"
                  />
                  <kl-label
                    :title="$t('public.AllUnBind')"
                    icon="icon-icon_operat_delete"
                    :iconSize="16"
                    :fontSize="12"
                    @click="removeAllSpeedLimitSet"
                    style="margin-right: 12px; cursor: pointer"
                  />
                </div>
              </div>
              <div style="height: 190px; overflow: auto">
                <el-table
                  v-loading="loading"
                  size="mini"
                  :data="lineBindVehicleList"
                  border
                  @row-click="tableVehicleClickRow"
                  highlight-current-row
                  style="width: 100%"
                >
                  <el-table-column type="index" align="center" width="45">
                  </el-table-column>
                  <el-table-column
                    prop="CarNo"
                    align="center"
                    :label="$t('vehicle.carNo')"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16" :offset="0">
          <div
            style="
              width: 100%;
              height: calc(100vh - 350px);
              background-color: #fff;
            "
          >
            <KingLongMap
              ref="map"
              mapId="content_12"
              @DrawPointCompleted="DrawPointCompleted"
            />
          </div>
          <div style="margin-top: 8px">
            <div style="display: flex; align-items: center">
              <span
                style="
                  flex: 1;
                  font-size: 12px;
                  font-weight: bold;
                  color: #0f1a3a;
                "
                >{{ $t("speedlimit.luduanxinx") }}</span
              >
              <div>
                <kl-label
                  @click="drawPoint"
                  :title="$t('speedlimit.setzhiluduan')"
                  icon="icon-icon_operat_increa"
                  :iconSize="16"
                  :fontSize="12"
                  style="margin-right: 12px; cursor: pointer"
                />
                <kl-label
                  :title="$t('speedlimit.xiuggailuduan')"
                  icon="icon-icon_operat_increa"
                  :iconSize="16"
                  :fontSize="12"
                  @click="editRoadPart"
                  style="margin-right: 12px; cursor: pointer"
                />
                <kl-label
                  :title="$t('speedlimit.shanchuluduan')"
                  icon="icon-icon_buslist_xxfb"
                  :iconSize="16"
                  :fontSize="12"
                  @click="removeAllRoadPart"
                  style="margin-right: 12px; cursor: pointer"
                />
              </div>
            </div>
            <div style="height: 150px; overflow: auto">
              <el-table
                v-loading="loading"
                size="mini"
                :data="linePartList"
                border
                @row-click="tablePartClickRow"
                highlight-current-row
                style="width: 100%"
              >
                <el-table-column type="index" align="center" width="45">
                </el-table-column>
                <el-table-column
                  prop="RoutePartName"
                  align="center"
                  :label="$t('arealimitset.partlinename')"
                >
                </el-table-column>
                <el-table-column
                  prop="MaxSpeed"
                  align="center"
                  :label="$t('arealimitset.hightspeed') + '(km/h)'"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <part_road_speed_limit_info ref="model" @ok="submitLineOk" />
    <road_part_edit ref="modeledit" @ok="submitEditOk" />
  </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap.vue";
import part_road_speed_limit_info from "./components/part_road_speed_limit_info";
import road_part_edit from "./components/road_part_edit";
import { mapState } from "vuex";
export default {
    name:"PartRoadSpeedlimit",
  components: { part_road_speed_limit_info, KingLongMap, road_part_edit },
  computed: {
    ...mapState({
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
    }),
    operator() {
      return this.$store.getters.operator;
    },
  },
  data() {
    return {
      loading: false,
      total: 100,
      lineList: [],
      lineBindVehicleList: [],
      linePartList: [],
      currentRow: undefined,
      currentVehicleRow: undefined,
      currentPartRow: undefined,
      drawing: false,
    };
  },
  methods: {
    tablePartClickRow(row) {
      this.currentPartRow = row;

      //显示路段
      this.RoutePartShow();
    },
    RoutePartShow() {
      var RoutePartName = this.currentPartRow.RoutePartName;
      var BPointNo = this.currentPartRow.BPointNo;
      var EPointNo = this.currentPartRow.EPointNo;

      var Points = this.currentRow.lonlats.split(";");
      var poiCount = Points.length;
      if (
        BPointNo != undefined &&
        EPointNo != undefined &&
        RoutePartName != undefined &&
        BPointNo >= 0 &&
        BPointNo < poiCount &&
        EPointNo <= poiCount &&
        EPointNo > BPointNo
      ) {
        if (EPointNo > poiCount) EPointNo = poiCount;
        if (BPointNo < 0) BPointNo = 0;

        var xy = [];
        var lineName = "RoutePart";
        var centerPoint = Points[BPointNo - 1].split(",");
        var centerX = centerPoint[0];
        var centerY = centerPoint[1];
        for (var i = BPointNo - 1; i < EPointNo; i++) {
          var p = Points[i].split(",");
          xy.push({ lng: parseFloat(p[0]), lat: parseFloat(p[1]) });
        }

        // console.log(xy);
        if (xy.length > 0) {
          this.$refs.map.removePolylineById("AREA21");
          this.$refs.map.addPolyline("AREA21", RoutePartName, xy, 5, 0xccccff);

          //     //
          //     mapWindow.contentWindow.KingLongMap.addPolyline(lineName, RoutePartName, xy, 8, '0x00CCFF');
          //     mapWindow.contentWindow.KingLongMap.setZoom(8);
          //     mapWindow.contentWindow.KingLongMap.setCenter(centerX, centerY);
          //     mapWindow.contentWindow.KingLongMap.showHighLineStringById(lineName);
          //     window.setTimeout(clearHideRoutePart, 3000);
          //     return;
        }
      }
    },
    submitEditOk() {
      //保存了路段信息
      this.queryRoadPartList();
    },
    setVehicleSpeedLimit() {
      //设置车辆限速
      if (this.currentRow == undefined) {
        this.$message({
          message: this.$t("speedlimit.qingxuanzexialu"),
          type: "warning",
        });
        return;
      }
      //选中左侧树的车辆
      var vids = this.getSelectedVehicles();
      if (vids == "") {
        //提示，请先选中车辆
        this.$message({
          message: this.$t("speedlimit.selectvehicleintree"),
          type: "warning",
        });
        return;
      }

      this.$api
        .bindVehicleAndRoute({
          routeId: this.currentRow.routeId,
          vehicleId: vids,
          OperatorID: this.operator.OperatorId,
        })
        .then((res) => {
          //设置成功
          this.$message({
            message: this.$t("public.SetSuccess"),
            type: "success",
          });
          this.queryRoadVehicleList();
        });
    },
    //获取选中的车辆
    getSelectedVehicles() {
      var vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    removeVehicleSpeedLimitSet() {
      if (this.currentRow == undefined) {
        this.$message({
          message: this.$t("speedlimit.qingxuanzexialu"),
          type: "warning",
        });
        return;
      }
      if (this.currentVehicleRow == undefined) {
        this.$message({
          message: this.$t("speedlimit.selectunbindvehicle"),
          type: "warning",
        });
        return;
      }

      //提示是否全部解除
      this.$confirm(
        this.$t("speedlimit.comfirmunbind"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      ).then(() => {
        //提交解除
        this.$api
          .removeVehicleAndRoute({
            routeId: this.currentRow.routeId,
            vehicleId: this.currentVehicleRow.VehicleID.toString(),
          })
          .then((res) => {
            this.$message({
              message: this.$t("public.cancelSuccess"),
              type: "success",
            });
            this.queryRoadVehicleList();
          });
      });
    },
    removeAllSpeedLimitSet() {
      //全部解除

      //判断是否已经选中了数据
      if (this.currentRow == undefined) {
        this.$message({
          message: this.$t("speedlimit.qingxuanzexialu"),
          type: "warning",
        });
        return;
      }

      var vids = "";
      //从车辆列表中获取车辆id
      this.lineBindVehicleList.forEach((element) => {
        if (vids != "") vids += ",";
        vids += element.VehicleID;
      });

      //提示是否全部解除
      this.$confirm(
        this.$t("speedlimit.comfirmallunbind"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      ).then(() => {
        //提交解除
        this.$api
          .removeAllVehicleAndRoute({
            routeId: this.currentRow.routeId,
            vehicleId: vids,
          })
          .then((res) => {
            //取消成功
            this.$message({
              message: this.$t("public.cancelSuccess"),
              type: "success",
            });
            this.queryRoadVehicleList();
          });
      });
    },
    submitLineOk() {
      this.queryAllLine();
    },
    queryAllLine() {
      this.$api
        .queryLimitRouteInfo({
          CompanyID: this.operator.CompanyId,
        })
        .then((res) => {
          this.lineList = res.data;
        });
    },
    editRoadPart() {
      if (!this.currentPartRow) {
        //提示，请先选择路段
        this.$message({
          message: this.$t("speedlimit.qiangxuanzeluduan"),
          type: "warning",
        });
        return;
      }
      //弹窗
      this.$refs.modeledit.show(this.currentPartRow);
    },
    removeAllRoadPart() {
      //删除所有路段
      if (this.currentRow == undefined) {
        this.$message({
          message: this.$t("speedlimit.qingxuanzexialu"),
          type: "warning",
        });
        return;
      }
      this.$confirm(
        this.$t("speedlimit.comfirshanchuluduan"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.$api
          .delRoutePartInfo({
            routeId: this.currentRow.routeId,
          })
          .then((res) => {
            this.$message({
              message: this.$t("public.hasDeleted"),
              type: "success",
            });
            this.queryRoadPartList();
          });
      });
    },
    drawPoint() {
      //画点
      //设置路段
      if (this.currentRow == undefined) {
        this.$message({
          message: this.$t("speedlimit.qingxuanzexialu"),
          type: "warning",
        });
        return;
      }
      if (this.currentRow.lnglats == "") {
        this.$message({
          message: this.$t("speedlimit.emptytrack"),
          type: "warning",
        });
        return;
      }

      if (this.drawing) {
        //正在画，取消画
        this.$refs.map.cancelDraw();
        this.drawing = false;
      } else {
        //根据选中类型进行

        this.$refs.map.drawPoint();

        this.drawing = true;

        this.showLine();
      }
    },
    DrawPointCompleted(lng, lat) {
      console.log(lng, lat);

      this.drawing = false;

      //点在不在线上
      lng = parseFloat(lng).toFixed(6);
      lat = parseFloat(lat).toFixed(6);
      var Points = this.currentRow.lonlats.split(";");

      var IndexForInsert = 1,
        PointToLine = undefined;
      for (var i = 1; i < Points.length; i++) {
        var t_prev = Points[i - 1].split(",");
        var prev = {
          lng: parseFloat(t_prev[0]).toFixed(6),
          lat: parseFloat(t_prev[1]).toFixed(6),
        };

        var t_now = Points[i].split(",");
        var now = {
          lng: parseFloat(t_now[0]).toFixed(6),
          lat: parseFloat(t_now[1]).toFixed(6),
        };
        var dis = this.$refs.map.pointToLineDist(
          prev.lng,
          prev.lat,
          now.lng,
          now.lat,
          lng,
          lat
        );
        if (PointToLine == undefined) {
          PointToLine = dis;
        } else if (dis < PointToLine) {
          PointToLine = dis;
          IndexForInsert = i;
        }
      }

      if (PointToLine > 10) {
        //5米
        this.drawPoint();
        //提示，需要重新绘制

        this.$message({
          message: this.$t("speedlimit.pointnotinline"),
          type: "warning",
        });

        return;
      }

      //提示是否确认保存
      this.$confirm(this.$t("speedlimit.saveluduan"), this.$t("public.tips"), {
        confirmButtonText: this.$t("public.confirm"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      }).then(() => {
        var SavePoints = [];
        for (var j = 0; j < Points.length; j++) {
          if (j == IndexForInsert) {
            SavePoints.push(lng + "," + lat);
          }

          SavePoints.push(Points[j]);
        }

        var CutPoints = [];
        if (this.currentRow.cutlonlats) {
          CutPoints = this.currentRow.cutlonlats.split(";");
        } else {
          //插入线路的第一点和最后一点
          CutPoints.push(Points[0]);
          CutPoints.push(Points[Points.length - 1]);
        }

        var SaveCutPoints = [];
        var kk = 0;
        for (var k = 0; k < CutPoints.length; k++) {
          var p = CutPoints[k].split(",");

          for (kk; kk < SavePoints.length; kk++) {
            var savePoint = SavePoints[kk].split(",");
            if (p[0] == savePoint[0] && p[1] == savePoint[1]) {
              SaveCutPoints.push(p[0] + "," + p[1] + "," + (kk + 1));
              break;
            }
            if (savePoint[0] == lng && savePoint[1] == lat) {
              SaveCutPoints.push(lng + "," + lat + "," + (kk + 1));
            }
          }
        }

        //保存
        this.$api
          .saveRoutePartInfo({
            routeId: this.currentRow.routeId,
            SavePoints: SavePoints.join(";"),
            CutOffPoint: SaveCutPoints.join(";"),
            CompanyID: this.operator.CompanyId,
            OperatorID: this.operator.OperatorId,
          })
          .then((res) => {
            this.$message({
              message: this.$t("public.hasSaved"),
              type: "success",
            });

            //重新画线
            this.queryRoadPartList();
            //重新加载列表
          });
      });
    },
    tableVehicleClickRow(row) {
      this.currentVehicleRow = row;
    },
    tableClickRow(row) {
      this.currentRow = row;
      this.$refs.map.clearAll();

      this.showLine();
      //查询线路绑定的车辆
      this.queryRoadVehicleList();
      //查询线路路段信息
      this.queryRoadPartList();
    },
    queryRoadPartList() {
      this.$api
        .queryRoadPartList({
          routeId: this.currentRow.routeId,
        })
        .then((res) => {
          this.linePartList = res.data;
        });
    },
    queryRoadVehicleList() {
      this.$api
        .queryRoadVehicleList({
          routeId: this.currentRow.routeId,
        })
        .then((res) => {
          this.lineBindVehicleList = res.data;
        });
    },
    showLine() {
      var row = this.currentRow;
      if (row && row.lonlats) {
        var circleInfo = row.lonlats.split(";");

        var coordanites = [];
        circleInfo.forEach((element) => {
          var p = element.split(",");
          coordanites.push({
            lng: parseFloat(p[0]),
            lat: parseFloat(p[1]),
          });
        });

        this.$refs.map.addPolyline(
          "AREA1",
          row.routeName,
          coordanites,
          5,
          0xcd3700
        );

        //有点要画点
      }
    },

    onAddLineClick() {
      this.$refs.model.add();
    },
    onEditClick() {
      if (!this.currentRow || this.currentRow == {}) {
        this.$message.warning(this.$t("speedlimit.selectonline"));
        return;
      }
      //获取选中的数据
      this.$refs.model.edit(this.currentRow);
    },
    onDelLineClick() {
      if (!this.currentRow || this.currentRow == {}) {
        this.$message.warning(this.$t("speedlimit.selectonline"));
        return;
      }
      //提示是否删除
      this.$confirm(this.$t("speedlimit.deleteline"), this.$t("public.tips"), {
        confirmButtonText: this.$t("public.confirm"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      })
        .then(() => {
          //删除
          this.$api
            .delLimitRouteInfo({
              routeId: this.currentRow.routeId,
            })
            .then((res) => {
              this.$message.success(this.$t("public.hasDeleted"));
              this.queryAllLine();
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    // this.$store.dispatch("app/closeSideBar");
    this.queryAllLine();
  },
  destroyed() {
    // this.$store.dispatch("app/openSideBar");
  },
};
</script>
